module.exports = __webpack_public_path__ + "img/expert-defaule-pic.389295f8.jpg";